/**
 * Check if value is nullish (null/undefined) or empty string
 * @param value - Value to check
 * @returns true if value is null, undefined, or empty string
 */
export const isEmptyOrNullish = (
  value: string | null | undefined
): value is null | undefined | '' => {
  return value === null || value === undefined || value === '';
};

/**
 * Coalesce multiple values, returning the first non-empty, non-nullish value
 * Similar to ?? operator but also treats empty strings as nullish
 * @param values - Values to check in order
 * @returns First non-empty, non-nullish value or undefined
 */
export function coalesceNonEmpty<T extends string | null | undefined>(
  ...values: T[]
): Exclude<T, null | undefined | ''> | undefined {
  return values.find(
    (value): value is Exclude<T, null | undefined | ''> => !isEmptyOrNullish(value)
  );
}
